<template>
  <common-card class="mt-3">
    <v-row>
      <v-col>
        <v-row style="padding: 15px 20px 0px 20px">
          <v-col cols="12" md="6">
            <h1>Administrador de asistencias y beneficios</h1>
          </v-col>
          <v-col cols="12" md="6" style="text-align: end">
            <v-btn
              class="common-botton"
              dark
              :loading="loading"
              @click="
                $router.push('/administracion/asistencias-beneficios/crear')
              "
            >
              <v-icon class="mr-2">mdi-plus</v-icon>
              <span>Nueva</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- Expansion Panel para Búsqueda detallada -->
    <v-expansion-panels
      elevation="0"
      style="padding: 30px; border-radius: 20px"
    >
      <v-expansion-panel>
        <v-expansion-panel-header style="padding: 35px">
          <h3 style="color: #42352e">Búsqueda detallada</h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                v-model="filtros.alianza"
                :items="alianzasOptions"
                item-text="nombre"
                item-value="id"
                label="Alianza"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                v-model="filtros.tipo"
                label="Tipo"
                :items="tipoOptions"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                v-model="filtros.categoria"
                label="Categoría"
                :items="categoriaOptions"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <v-autocomplete
                v-model="filtros.proveedor"
                label="Proveedor"
                :items="proveedorOptions"
                item-text="nombre"
                item-value="id"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                v-model="filtros.status"
                label="Estatus"
                :items="statusOptions"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-autocomplete>
            </v-col>
            <v-col cols="4">
              <v-text-field
                v-model="filtros.nombre"
                label="Nombre"
                outlined
                dense
                color="primary"
                background-color="white"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Botones alineados a la derecha -->
          <v-row style="padding: 0px 40px 0px 40px" class="d-flex justify-end">
            <v-col cols="12" md="2">
              <v-btn
                dark
                block
                outlined
                color="#00a7e4"
                rounded
                @click="limpiarFiltros()"
              >
                Limpiar
              </v-btn>
            </v-col>
            <v-col cols="12" md="2" style="text-align: end">
              <v-btn
                class="common-botton"
                dark
                block
                :disabled="filtersIncomplete"
                :loading="loading"
                @click="filtros.pagina = 1; getBeneficios()"
              >
                <span>Filtrar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <div style="padding: 0px 40px 0px 40px">
      <hr />
    </div>

    <!-- Tabla de resultados -->
    <v-row>
      <v-col cols="12" class="mb-10" style="padding: 40px">
        <v-data-table
          style=""
          :headers="headers"
          @pagination="pagination"
          :server-items-length="totalBeneficios"
          :page.sync="filtros.pagina"
          :items-per-page.sync="filtros.elementosPagina"
          :items="beneficios"
          item-key="id"
          class="elevation-0"
          :loading="loading"
          loading-text="Cargando..."
          no-data-text="Para ver elementos, primero realiza una búsqueda"
        >
          <template v-slot:top>
            <v-row style="padding: 15px">
              <v-col cols="8">
                <h2>Resultados de la búsqueda</h2>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.status="{ item }">
            <div>
              <v-chip :color="getStatusColor(item.status)" dark>
                {{ item.status }}
              </v-chip>
            </div>
          </template>

          <template v-slot:item.monto="{ item }">
            <span>${{ formatMonto(item.monto) }}</span>
          </template>

          <template v-slot:item.ver="{ item }">
            <v-icon small class="mr-2" @click="verDetalles(item)">
              mdi-eye
            </v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </common-card>
</template>

<script>
import { mainAxios } from "../../../../mainAxios";
import CommonCard from "@/components/commonComponents/CommonCard.vue";
import { getAlianzas } from "../../../../services/alianzas/alianzas.service";
import {
  getCategorias,
  getProveedor,
} from "../../../../services/clubBeneficios/clubBeneficios";

export default {
  name: "TablaClubBeneficios",
  components: {
    CommonCard,
  },
  data() {
    return {
      beneficios: [],
      totalBeneficios: 0,
      headers: [
        {
          text: "ID Beneficio",
          align: "start",
          sortable: false,
          value: "id",
        },
        {
          text: "Tipo",
          sortable: false,
          value: "tipo",
        },
        {
          text: "Nombre",
          sortable: false,
          value: "nombre",
        },
        {
          text: "Nombre Corto",
          value: "nombreCorto",
        },
        {
          text: "Periodicidad",
          value: "periodicidad",
        },
        {
          text: "Monto",
          value: "monto",
        },
        {
          text: "Eventos por Periodo",
          value: "eventosPeriodo",
        },
        {
          text: "Mes Disponibilidad",
          value: "mesDisponibilidad",
        },
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Ver",
          value: "ver",
          sortable: false,
        },
      ],
      filtros: {
        alianza: null,
        nombre: null,
        status: null,
        tipo: null,
        categoria: null,
        proveedor: null,
        pagina: 1,
        elementosPagina: 10,
      },
      loading: false,
      statusOptions: [],
      tipoOptions: [],
      alianzasOptions: [],
      categoriaOptions: [],
      proveedorOptions: [],
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      roles: JSON.parse(localStorage.getItem("roles")),
    };
  },

  computed: {
    filtersIncomplete() {
      return Object.values(this.filtros).every((v) => v === null || v === "");
    },
    canViewCreate() {
      let canView = false;
      let roles = [];
      this.roles.forEach((element) => {
        roles.push(element.rol);
      });
      const rolesToView = ["ADMIN", "MANAGERCC", "OPERADOR"];
      roles.forEach((element) => {
        if (rolesToView.includes(element)) {
          canView = true;
        }
      });
      return canView;
    },
  },

  mounted() {
    this.getAlianzasOptions();
    this.getCategoriasOptions();
    this.getProveedorOptions();
    this.getStatusOptions();
    this.getTipoOptions();
  },

  methods: {
    getBeneficios() {
      this.loading = true;
      let config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      const queryParams = this.buildQueryParams();

      mainAxios
        .get(`/v1/club-beneficios/${queryParams}`, config)
        .then((response) => {
          this.beneficios = response.data.data.beneficios;
          this.totalBeneficios = response.data.data.count;
        })
        .catch((error) => {
          console.error("Error al obtener beneficios:", error);
          this.$toast.error("Error al cargar los beneficios", {
            position: "top-right",
            timeout: 3000,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getStatusOptions() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      mainAxios
        .get("/v1/club-beneficios/status", config)
        .then((response) => {
          this.statusOptions = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener status:", error);
        });
    },

    getTipoOptions() {
      const config = {
        headers: {
          Authorization: "Bearer " + localStorage.agenteAccessToken,
        },
      };

      mainAxios
        .get("/v1/club-beneficios/tipos", config)
        .then((response) => {
          this.tipoOptions = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener tipos:", error);
        });
    },

    async getAlianzasOptions() {
      this.alianzasOptions = await getAlianzas();
    },

    async getCategoriasOptions() {
      this.categoriaOptions = await getCategorias();
    },

    async getProveedorOptions() {
      this.proveedorOptions = await getProveedor();
    },

    buildQueryParams() {
      let params = "?";

      if (this.filtros.nombre) {
        params += `nombre=${this.filtros.nombre}&`;
      }

      if (this.filtros.status) {
        params += `status=${this.filtros.status}&`;
      }

      if (this.filtros.tipo) {
        params += `tipo=${this.filtros.tipo}&`;
      }

      if (this.filtros.alianza) {
        params += `alianza=${this.filtros.alianza}&`;
      }

      if (this.filtros.categoria) {
        params += `categoria=${this.filtros.categoria}&`;
      }

      if (this.filtros.proveedor) {
        params += `proveedor=${this.filtros.proveedor}&`;
      }

      params += `pagina=${this.filtros.pagina}&elementosPagina=${this.filtros.elementosPagina}`;

      return params;
    },

    getStatusColor(status) {
      const statusColors = {
        Activo: "green",
        Inactivo: "amber darken-2",
        Baja: "red",
      };

      return statusColors[status] || "grey";
    },

    formatMonto(monto) {
      return monto.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
    },

    verDetalles(item) {
      this.$router.push(
        `/administracion/asistencias-beneficios/editar/${item.id}`,
      );
    },

    pagination(event) {
      console.log("Pagination event:", event);
      this.getBeneficios();
    },

    limpiarFiltros() {
      this.filtros = {
        nombre: null,
        status: null,
        tipo: null,
        alianza: null,
        categoria: null,
        proveedor: null,
        pagina: 1,
        elementosPagina: 10,
      };

      this.beneficios = [];
      this.totalBeneficios = 0;
    },

    downloadReport() {
      this.loading = true;

      const queryParams = this.buildQueryParams();

      mainAxios
        .get(`/v1/club-beneficios/reporte${queryParams}`, {
          headers: {
            Authorization: `Bearer ${localStorage.agenteAccessToken}`,
          },
          responseType: "blob",
        })
        .then((res) => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Reporte_asistencias_beneficios.csv");
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .catch((err) => {
          console.error(err);
          this.$toast.error("Error al descargar el reporte", {
            position: "top-right",
            timeout: 3000,
          });
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped>
.theme--light.v-data-table {
  background-color: #f2fafc;
  color: rgba(0, 0, 0, 0.87);
  border-radius: 20px;
}

.v-expansion-panel {
  border-radius: 20px;
}

.v-expansion-panels {
  z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
}

.theme--light.v-expansion-panels .v-expansion-panel {
  background-color: #f6f5f9;
  color: rgba(0, 0, 0, 0.87);
}

.common-botton {
  background-color: #00a7e4 !important;
}
</style>
